import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import LoginAnnouncementsDialog from './LoginAnnouncementsDialog';
import {
  clearLoginAnnouncementsPending,
  shouldShowLoginAnnouncements,
} from '../utils/loginAnnouncements';

function LoginAnnouncementsGate() {
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setOpen(false);
      return;
    }

    setOpen(shouldShowLoginAnnouncements());
  }, [isAuthenticated]);

  const handleClose = () => {
    clearLoginAnnouncementsPending();
    setOpen(false);
  };

  return <LoginAnnouncementsDialog open={open} onClose={handleClose} />;
}

export default LoginAnnouncementsGate;
